export default __webpack_public_path__ + "static/media/business-agility.276cea14.jpg";